// extracted by mini-css-extract-plugin
module.exports = {"regionDisabled":"style_regionDisabled__3-mqe"};